import { render, staticRenderFns } from "./BbMain.vue?vue&type=template&id=d12b6660&"
import script from "./BbMain.vue?vue&type=script&lang=js&"
export * from "./BbMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports